/** Texte des gemeinsamen Bankdialogs (PIN, TAN, Freigabe, Bankschlüssel, Empfängerprüfung). Produkte spreaden sie in ihr Wörterbuch. */
export const bankingDe: Record<string, string> = {
  "banking.fetchFrom": "Umsätze ab",
  "banking.fetchFromInvalid": "Wähle ein Startdatum, das nicht in der Zukunft liegt.",
  "banking.changeSecurityMethod": "Verfahren und Gerät ändern",
  "banking.cancelled": "Die Bankanfrage wurde abgebrochen.",
  "banking.cancelling": "Die Bankanfrage wird abgebrochen. Bitte warte auf die Bestätigung.",
  "banking.operationLost": "Der Bankvorgang ist nicht mehr verfügbar. Prüfe den Verbindungsstatus, bevor du einen neuen Vorgang startest.",
  "banking.pin": "PIN",
  "banking.filePassword": "PIN der Sicherheitsdatei",
  "banking.savePin": "PIN speichern",
  "banking.saveFilePassword": "Passwort speichern",
  "banking.appApproval": "Freigabe in der Banking-App",
  "banking.verifyBankKey": "Bankschlüssel prüfen",
  "banking.securityFileEntry": "Bankzugang in der Sicherheitsdatei",
  "banking.payeeCheck": "Empfängerüberprüfung",
  "banking.enterTan": "TAN eingeben",
  "banking.approvalCompleted": "Freigabe prüfen",
  "banking.executeOrder": "Auftrag ausführen",
  "banking.continue": "fortfahren",
  "banking.cancelOrder": "Auftrag abbrechen",
  "banking.payeeCheckInstruction": "Name und Konto stimmen nicht oder nur teilweise überein. Wird der Auftrag trotzdem ausgeführt, haftet die Bank nicht, falls das Geld beim falschen Empfänger ankommt.",
  "banking.tanImage": "Grafik für den TAN-Generator",
  "banking.verifyBankKeyInstruction": "Vergleiche den angezeigten Prüfwert mit den unabhängig bezogenen Unterlagen deiner Bank und trage den Prüfwert aus diesen Unterlagen ein.",
  "banking.bankDocumentFingerprint": "Prüfwert aus den Bankunterlagen",
  "banking.tanMethod": "TAN-Verfahren",
  "banking.selectTanMethod": "TAN-Verfahren auswählen",
  "banking.selectTanMedium": "Freigabegerät auswählen",
  "banking.fileEntryInstruction": "Wähle den Bankzugang aus deiner Sicherheitsdatei.",
  "banking.appApprovalInstruction": "Gib die Anfrage in deiner Banking-App frei. Klicke anschließend auf „Freigabe prüfen“.",
  "banking.tanMedium": "Freigabegerät",
  "banking.processing": "Die Bankanfrage läuft. Bitte warte auf die Antwort deiner Bank.",
  "banking.tanMethodInstruction": "Wähle das Sicherheitsverfahren für diesen Bankzugang.",
  "banking.tanMediumInstruction": "Wähle das Gerät, auf dem du die Bankanfrage freigeben möchtest.",
  "banking.credentialsRequired": "Der Bankzugang konnte nicht entsperrt werden. Bitte Kennung, PIN und gegebenenfalls die Sicherheitsdatei prüfen.",
  "banking.fileRequired": "Bitte für dieses Zugangsverfahren eine Sicherheitsdatei und deren Datei-PIN angeben.",
  "banking.attemptsExceeded": "Abgebrochen: Die Bank hat die Anmeldung mehrfach abgelehnt. Ein gespeichertes Passwort wurde gelöscht. Bitte die Zugangsdaten prüfen, bevor die Bank den Zugang sperrt.",
  "banking.failed": "Der Bankabruf ist fehlgeschlagen. Es wurde kein automatischer Wiederholungsversuch gestartet.",
  "banking.opticalSignal": "Optisches TAN-Signal",
  "banking.start": "Start",
  "banking.stop": "Stopp",
  "banking.opticalWidth": "Breite",
  "banking.opticalSpeed": "Geschwindigkeit",
};

export const bankingEn: Record<string, string> = {
  "banking.fetchFrom": "Transactions from",
  "banking.fetchFromInvalid": "Choose a start date that is not in the future.",
  "banking.changeSecurityMethod": "Change method and device",
  "banking.cancelled": "The bank request was cancelled.",
  "banking.cancelling": "Cancelling the bank request. Please wait for confirmation.",
  "banking.operationLost": "The bank operation is no longer available. Check its status before starting a new operation.",
  "banking.pin": "PIN",
  "banking.filePassword": "Security file PIN",
  "banking.savePin": "Save PIN",
  "banking.saveFilePassword": "Save password",
  "banking.appApproval": "Approve in your banking app",
  "banking.verifyBankKey": "Verify bank key",
  "banking.securityFileEntry": "Bank access in the security file",
  "banking.payeeCheck": "Payee verification",
  "banking.enterTan": "Enter TAN",
  "banking.approvalCompleted": "Check approval",
  "banking.executeOrder": "Execute order",
  "banking.continue": "Continue",
  "banking.cancelOrder": "Cancel order",
  "banking.payeeCheckInstruction": "Name and account do not or only partly match. If the order is executed anyway, the bank is not liable should the money reach the wrong payee.",
  "banking.tanImage": "TAN generator image",
  "banking.verifyBankKeyInstruction": "Compare this fingerprint with independently obtained bank documents and enter the fingerprint from those documents.",
  "banking.bankDocumentFingerprint": "Fingerprint from bank documents",
  "banking.tanMethod": "TAN method",
  "banking.selectTanMethod": "Select TAN method",
  "banking.selectTanMedium": "Select approval device",
  "banking.fileEntryInstruction": "Select the bank access from your security file.",
  "banking.appApprovalInstruction": "Approve the request in your banking app. Then click “Check approval”.",
  "banking.tanMedium": "Approval device",
  "banking.processing": "Checking the bank connection. Please wait for your bank's response.",
  "banking.tanMethodInstruction": "Select the security method for this bank access.",
  "banking.tanMediumInstruction": "Select the device on which you want to approve the bank request.",
  "banking.credentialsRequired": "The bank access could not be unlocked. Check your user ID, PIN and security file.",
  "banking.fileRequired": "Provide a security file and its file password for this access method.",
  "banking.attemptsExceeded": "Cancelled: the bank rejected the sign-in repeatedly. A saved password was deleted. Check the credentials before the bank locks the access.",
  "banking.failed": "The bank request failed. No automatic retry was started.",
  "banking.opticalSignal": "Optical TAN signal",
  "banking.start": "Start",
  "banking.stop": "Stop",
  "banking.opticalWidth": "Width",
  "banking.opticalSpeed": "Speed",
};
